export default {
      id: "policy-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#policy",
      toString: function () {
        return this.url;
      }
    }